import { Radar } from "lucide-react";
import ButtonSlideMenu from "./ButtonSlideMenu";
import CompetitorScopeFlowModals from "../CompetitorScope/CompetitorScopeFlowModals";
import { COMPETITOR_SCOPE_MENU_ITEM } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { useOpenCompetitorScopeFlow } from "../../hooks/useOpenCompetitorScopeFlow";

const ButtonOpenCompetitorScope = ({ onTabletLinkClick = () => {} }) => {
  const { t } = useTranslationApp();
  const { openCompetitorScope, modalsProps } = useOpenCompetitorScopeFlow({
    onBeforeOpen: onTabletLinkClick,
  });

  return (
    <>
      <ButtonSlideMenu
        id="button-open-competitor-scope"
        startIcon={<Radar className="w-5 h-5" />}
        onClick={openCompetitorScope}
      >
        {t(COMPETITOR_SCOPE_MENU_ITEM)}
      </ButtonSlideMenu>

      <CompetitorScopeFlowModals {...modalsProps} />
    </>
  );
};

export default ButtonOpenCompetitorScope;
